import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultNS, fallbackLng, resources, supportedLngs } from './resources';

// `initReactI18next` rejestruje tę instancję globalnie, dzięki czemu `useTranslation()` i
// `<Trans>` nie potrzebują providera (w Next.js analogicznie: jeden singleton z next-intl
// zamiast Contextu przy każdym drzewie). `import { t } from 'i18next'` też trafia w nią,
// więc utile i testy tłumaczą bez Reacta.
//
// Zasoby są wbudowane w bundle, więc `init` kończy się synchronicznie i pierwszy render
// ma już teksty. `initAsync: false` robi z tego gwarancję, nie przypadek.
i18n.use(initReactI18next).init({
  resources,
  lng: fallbackLng,
  fallbackLng,
  supportedLngs,
  defaultNS,
  ns: Object.keys(resources[fallbackLng]),
  initAsync: false,
  // React już escapuje wartości w JSX, drugie escapowanie psułoby np. apostrofy i `&`.
  interpolation: { escapeValue: false },
});

const syncDocumentLang = (lng: string) => {
  document.documentElement.lang = lng;
};

syncDocumentLang(i18n.language);
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
